import { render } from "./Header.vue?vue&type=template&id=476d5bfa"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/public/newAccount/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "476d5bfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('476d5bfa', __exports__)) {
    api.reload('476d5bfa', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=476d5bfa", () => {
    api.rerender('476d5bfa', render)
  })

}


export default __exports__